/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PossibleAnswer
 */
export interface PossibleAnswer {
    /**
     * 
     * @type {string}
     * @memberof PossibleAnswer
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof PossibleAnswer
     */
    number: number;
    /**
     * 
     * @type {string}
     * @memberof PossibleAnswer
     */
    content: string;
}

/**
 * Check if a given object implements the PossibleAnswer interface.
 */
export function instanceOfPossibleAnswer(value: object): value is PossibleAnswer {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function PossibleAnswerFromJSON(json: any): PossibleAnswer {
    return PossibleAnswerFromJSONTyped(json, false);
}

export function PossibleAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PossibleAnswer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'],
        'content': json['content'],
    };
}

export function PossibleAnswerToJSON(json: any): PossibleAnswer {
    return PossibleAnswerToJSONTyped(json, false);
}

export function PossibleAnswerToJSONTyped(value?: PossibleAnswer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'number': value['number'],
        'content': value['content'],
    };
}

